interface ISsCentrifugePaymentsChannel {
  id: number; // 1033627;
  amount_cents: number; // 498;
  currency: string; // 'USD';
  action: string; // 'deposit';
  payment_system: string; // 'CoinsPaid v2';
  recallable: boolean; // false;
  created_at: string; // '2021-03-24T14:21:59.646Z';
  finished_at: string; // '2021-03-24T14:21:59.645Z';
  system_name: string; // 'coinspaid';
  success: boolean; // true;
  blockchain_transaction_id: string; // 'a5ba292f11f829b65f86e77306db60e31247dfb20a93c228abdafad13f9dc7fb';
}

interface ISsCentrifugeBonusesChannel {
  id: number; // 381736
  title: string; // "test"
  created_at: string; // "2021-03-18T16:48:51.133Z"
  valid_until: string; // "2021-03-31T00:00:00.000Z",
  activatable: boolean; // false,
  cancelable: boolean; // true
  amount_cents: number; // 100000000,
  currency: string; // "BTC"
  stage: 'handle_bets' | 'issued' | 'canceled' | 'wager_done' | 'expired'; // "issued"
  strategy: string; // "personal"
  amount_wager_requirement_cents: number; // 1000000000
  amount_wager_cents: number; // 0
  activatable_until: null; // null
}

interface ISsCentrifugeFreespinsChannel {
  id: number; // 668946;
  title: string; // 'VIP ISoftBet Cherry Trio BTC';
  created_at: string; // '2021-03-18T17:12:57.685Z';
  valid_until: null;
  activatable: boolean; //  true;
  cancelable: boolean; // true;
  freespins_total: number; // 1;
  freespins_performed: null;
  bet_level: null;
  stage: 'handle_bets' | 'issued' | 'canceled' | 'wager_done' | 'expired'; // "issued"
  games: string[]; // ['isoftbet/Cherry'];
  games_info: [
    {
      identifier: string; // 'isoftbet/Cherry';
      title: string; // 'Cherry Trio';
      frontend_url: string; // 'cherry-trio';
    }
  ];
  activation_path: string; // '/profile/bonuses/freespins/668946/activate';
  provider: string; // 'isoftbet';
  currency: string; // 'BTC';
  activatable_until: string; // '2021-03-21T17:12:57.683Z';
  activation_condition: null;
}

export interface ISsCentrifugeGroupsChannel {
  id: string;
  name: string;
  status: boolean;
  writable: boolean;
  conditions: any[];
}
export interface ISsCentrifugeMaxBetChannel {
  game: string;
  currency: string; // 'BTC';
  amount_cents: number;
  limit_cents: number;
  reason: 'bonus_bet_limit_exceeded';
}

interface ISsCentrifugeCompointsChannel {
  chargeable: {
    points: number; // 0;
  };
  persistent: {
    points: number; // 5;
  };
}
export interface ISsCentrifugeBalanceChannel {
  currency: string; // 'USD';
  amount_cents: number;
  available_to_cashout_cents: number;
  available_to_bet_with_locked_cents: number;
  hidden_at: string | null; // 2020-02-02T00:00:00Z
  deposit_available: boolean;
  active: boolean;
  selected_lottery_id: number | null;
}

type TWebSocketBodyData =
  | ISsCentrifugePaymentsChannel
  | ISsCentrifugeFreespinsChannel
  | ISsCentrifugeBonusesChannel
  | ISsCentrifugeCompointsChannel
  | ISsCentrifugeGroupsChannel[]
  | ISsCentrifugeBalanceChannel
  | ISsCentrifugeMaxBetChannel;

export enum EWebSocketPrivateChannels {
  freespins = 'freespins_changes',
  bonuses = 'bonuses_changes',
  payments = 'payments_changes',
  compoints = 'comps_award',
  tournaments = 'tournaments_statuses',
  tournamentsNotifications = 'tournament_notifications',
  groups = 'groups_updates',
  balance = 'balance',
  gameLimits = 'game_limits',
}

interface IWebSocketBody {
  channel: EWebSocketPrivateChannels;
  data: TWebSocketBodyData;
  uid: string; // "f7pXU9yKJ2YIq7BKq7GTwX"
}

export interface IWebSocketMessage {
  body: IWebSocketBody;
  method: string; // "message"
}

export interface IWebSocketMessageExtended extends IWebSocketMessage {
  channelName: EWebSocketPrivateChannels;
  isPrivateChannel: boolean;
}

export interface IWebSocketChannel {
  socket?: WebSocket;
  subscribers: {
    [key in EWebSocketPrivateChannels]?: {
      (message: IWebSocketMessage): void;
    };
  };
}

export enum ESubscriptionStatus {
  noData = 'noData',
  connected = 'connected',
  connectInProgress = 'connectInProgress',
  subscribeInProgress = 'subscribeInProgress',
  subscribed = 'subscribed',
  unsubscribed = 'unsubscribed',
  unsubscribeInProgress = 'unsubscribeInProgress',
  disconnecting = 'disconnecting',
  disconnected = 'disconnected',
  error = 'error',
}

export type TSubscribeStatus = {
  [key in EWebSocketPrivateChannels]?: ESubscriptionStatus;
};
